import { FormJourneyItem, LeadForm } from "@plura/shared/types";
import { motion } from "framer-motion";
import { cn } from "@plura/shared/utils";
import CheckboxGroup from "../../../../molecules/CheckboxGroup";
import { useFormContext } from "react-hook-form";
import { dynamicQuestionContent, getCurrentResponseScore } from "@plura/shared/lead-forms";

interface Props {
  id: string;
  step: FormJourneyItem
  leadForm: LeadForm;
  editorMode: boolean;
  previewMode: boolean;
  active: boolean;
  handleAnswer?: () => void;
  onContentClick?: (fieldName: string, blockId: string) => void;
  hiddenFields?: {
    field: string;
    value: string;
  }[];
}

const MultiChoiceScreen = ({ id, step, editorMode, previewMode, leadForm, active, handleAnswer, onContentClick, hiddenFields }: Props) => {
  const form = useFormContext();
  const { conversationId, ...userResponses } = form.getValues()
  const currentResponseScore = userResponses
    ? getCurrentResponseScore(userResponses, leadForm)
    : 0
  const selectedOptions = form.getValues(step.blockId) || []

  const handleContentClick = (field: 'content' | 'secondaryContent') => {
    if ((!editorMode || (editorMode && previewMode)) || !onContentClick) return
    onContentClick(field, id)
  }

  return (
    <div className={cn('questionInner')}>
      <div>
        <h4
          onClick={() => handleContentClick('content')}
          className={
            cn(
              selectedOptions.length && 'semiFade',
              'question',
            )}
        >
          <motion.span dangerouslySetInnerHTML={{
            __html: dynamicQuestionContent({
              content: step.content,
              score: currentResponseScore,
              editMode: editorMode,
              previewMode: previewMode ?? false,
              hiddenFields,
              journeyItems: leadForm.journeyItems ?? [],
              userResponses
            })
          }} />
        </h4>
        {
          step.secondaryContent &&
          <p
            onClick={() => handleContentClick('secondaryContent')}
            className={
              cn(
                selectedOptions?.length && 'semiFade',
                'caption',
              )}
          >
            <motion.span
              dangerouslySetInnerHTML={{
                __html: dynamicQuestionContent({
                  content: step.secondaryContent,
                  score: currentResponseScore,
                  editMode: editorMode,
                  previewMode: previewMode ?? false,
                  hiddenFields,
                  journeyItems: leadForm.journeyItems ?? [],
                  userResponses
                })
              }}
            />
          </p>
        }
      </div>
      <motion.div className={'answerInputWrapper'}>
        <div className={'multiChoice'}>
          <CheckboxGroup
            elementType={leadForm.elementType}
            id={step.blockId}
            layout={step.horizontalAlignment ? 'horizontal' : 'vertical'}
            multiple={!!step.multiSelect && step.type === 'MULTIPLE_CHOICE'}
            disabledKeySelection={(editorMode && !previewMode) || !active}
            hideKeyHints={leadForm.showAnswerLetters === false}
            showOtherOption={!!step.otherOption}
            options={
              step.selectOptions?.sort((a, b) => a.order - b.order).map(o => ({
                value: o.id,
                label: o.value,
                media: o.mediaSettings?.media ?? null
              })) ?? []
            }
            handleOnChange={handleAnswer}
          />
        </div>
      </motion.div>
    </div>
  );
};


export default MultiChoiceScreen